"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (createUi) {
    return function (args) {
        var template = __assign(__assign({}, args), { thumbnailImage: "".concat(!!args.template.image
                ? "/Assets/Images/templates/thumbnails/" + args.template.image
                : "/Assets/Images/templates/thumbnails/template-empty.png"), activeIcon: "/Assets/icons/tick.svg" });
        return createUi(require("./TemplateThumbnail.html"), template);
    };
});
